import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/projects.ts
const PROJECT_NAME_MAX_CHARS = 120;
const PROJECT_SLUG_MAX_CHARS = 80;
const ACTIVE_PROJECT_LIMIT = 500;
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const timestampMsSchema = z$1.number().int().nonnegative();
const repositoryFingerprintSchema = z$1.string().regex(/^sha256:[a-f0-9]{64}$/u);
const repositoryUrlSchema = z$1.string().trim().max(2048).refine((value) => {
	try {
		const url = new URL(value);
		return url.protocol === "https:" && url.username === "" && url.password === "" && url.search === "" && url.hash === "" && url.pathname !== "/";
	} catch {
		return false;
	}
}, "Repository URL must be a safe canonical HTTPS URL.");
const projectSlugSchema = z$1.string().trim().min(1).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/u);
const projectSchema = z$1.strictObject({
	archivedAtMs: timestampMsSchema.nullable(),
	canArchive: z$1.boolean(),
	canManage: z$1.boolean(),
	createdAtMs: timestampMsSchema,
	createdByUserId: boundedIdentifierSchema,
	id: boundedIdentifierSchema,
	name: z$1.string().trim().min(1).max(120),
	organizationId: boundedIdentifierSchema,
	repositoryFingerprint: repositoryFingerprintSchema.nullable(),
	repositoryUrl: repositoryUrlSchema.nullable().optional(),
	slug: projectSlugSchema,
	updatedAtMs: timestampMsSchema
});
const createProjectBodySchema = z$1.strictObject({
	operationId: boundedIdentifierSchema.optional(),
	expectedOrganizationId: boundedIdentifierSchema,
	name: z$1.string().trim().min(1).max(120),
	repositoryFingerprint: repositoryFingerprintSchema.optional(),
	repositoryUrl: repositoryUrlSchema.optional(),
	slug: projectSlugSchema.optional()
});
const listProjectsQuerySchema = z$1.strictObject({});
const listProjectsResponseSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	projects: z$1.array(projectSchema).max(500)
});
const createProjectResponseSchema = z$1.strictObject({ project: projectSchema });
const projectRouteParamsSchema = z$1.strictObject({ projectId: boundedIdentifierSchema });
const projectUpdateShape = {
	name: z$1.string().trim().min(1).max(120).optional(),
	repositoryFingerprint: repositoryFingerprintSchema.nullable().optional(),
	repositoryUrl: repositoryUrlSchema.nullable().optional(),
	slug: projectSlugSchema.optional()
};
const hasProjectUpdate = (value) => value.name !== void 0 || value.repositoryFingerprint !== void 0 || value.repositoryUrl !== void 0 || value.slug !== void 0;
const updateProjectBodySchema = z$1.strictObject({
	expectedOrganizationId: boundedIdentifierSchema,
	...projectUpdateShape
}).refine(hasProjectUpdate, "At least one Project field must be updated.");
const updateProjectResponseSchema = z$1.strictObject({ project: projectSchema });
const archiveProjectBodySchema = z$1.strictObject({ expectedOrganizationId: boundedIdentifierSchema });
const archiveProjectResponseSchema = z$1.strictObject({ project: projectSchema });
const projectRpcContextShape = { context: openMeldRequestContextSchema.optional() };
const listProjectsRpcInputSchema = z$1.strictObject({ ...projectRpcContextShape });
const createProjectRpcInputSchema = z$1.strictObject({
	...projectRpcContextShape,
	...createProjectBodySchema.shape
});
const updateProjectRpcInputSchema = z$1.strictObject({
	...projectRpcContextShape,
	expectedOrganizationId: boundedIdentifierSchema,
	...projectRouteParamsSchema.shape,
	...projectUpdateShape
}).refine(hasProjectUpdate, "At least one Project field must be updated.");
const archiveProjectRpcInputSchema = z$1.strictObject({
	...projectRpcContextShape,
	...archiveProjectBodySchema.shape,
	...projectRouteParamsSchema.shape
});
//#endregion
export { ACTIVE_PROJECT_LIMIT, PROJECT_NAME_MAX_CHARS, PROJECT_SLUG_MAX_CHARS, archiveProjectBodySchema, archiveProjectResponseSchema, archiveProjectRpcInputSchema, createProjectBodySchema, createProjectResponseSchema, createProjectRpcInputSchema, listProjectsQuerySchema, listProjectsResponseSchema, listProjectsRpcInputSchema, projectRouteParamsSchema, projectSchema, projectSlugSchema, repositoryFingerprintSchema, repositoryUrlSchema, updateProjectBodySchema, updateProjectResponseSchema, updateProjectRpcInputSchema };

//# sourceMappingURL=projects.js.map